import React from "react";
import {
  KeyboardAvoidingView,
  View,
  StyleSheet,
  ScrollView,
  Keyboard,
} from "react-native";

import { sortBy } from "lodash";
import moment from "moment";

import { isWeb, navigate } from "../../../../helpers/utils";
import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";
import Header from "../../common/header/index";
import LoadingIndicator from "../../common/LoadingIndicator";
import ReflectionHelper from "../../reflection/ReflectionHelper";
import ReportComment from "./ReportComment";
import ReportJournalsList from "../preview/ReportJournalsList";
import ReportsHelper from "../ReportsHelper";
import appPages from "../../../../appPages";
import CommentInput from "./CommentInput";
import { cardShadow } from "../../../../styles/shadows";

export default class ReportCommentsPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.controller = props.controller;
    this.state = {
      report: null,
      selectedComment: null,
    };
  }

  getArgs() {
    if (this.controller.hasNavigation()) {
      return this.props.route.params;
    } else {
      return this.controller.state.screenArgs?.args;
    }
  }

  componentDidMount = async () => {
    const { reportId } = this.getArgs() || {};

    // Check
    if (!reportId) {
      return navigate(this.controller, appPages.receivedReports);
    }

    this._fetchReportById(reportId);
  };

  _fetchReportById = (reportId) => {
    this.setState((state) => ({ ...state, isLoading: true }));

    this.controller.getApiData(
      `report:${reportId}`,
      { reportId: reportId },
      (report) => {
        this.setState((state) => ({
          ...state,
          reportId,
          isLoading: false,
          selectedComment: null,
          report: {
            ...report,
            comment: report.description, // for overall comment
          },
        }));
      },
    );
  };

  goBack = () => {
    return this.controller.goBack();
  };

  editComment = (selectedComment) => {
    this.setState((state) => ({ ...state, selectedComment }));
  };

  // ------------------------------------- SAVE -------------------------------------
  saveComment = (comment) => {
    const { reportId } = this.state;

    if (!comment) return;

    let action = {
      action: "save",
      target: "report_comment",
      report_id: reportId,
      message: comment.message,
    };

    if (comment) {
      action.id = comment.id;
    }

    // Save comment into DB
    this.controller.cardActionWithCallback(action, () => {
      this._fetchReportById(reportId);
    });

    Keyboard.dismiss();
  };

  deleteComment = (comment) => {
    const { reportId } = this.state;

    if (!comment?.id) return;

    let action = {
      action: "delete",
      target: "report_comment",
      report_id: reportId,
      id: comment.id,
    };

    console.debug("-------------------->", action);

    // Save comment into DB
    //this.controller.cardActionWithCallback(action, () => {
    this._fetchReportById(reportId);
    //});
  };

  marAsUnread = (comment) => {
    const { reportId } = this.state;

    if (!comment?.id) return;

    let action = {
      action: "save",
      target: "report_comment",
      report_id: reportId,
      id: comment.id,
      was_read: comment.was_read,
    };

    // Save comment into DB
    this.controller.cardActionWithCallback(action, () => {
      this.goBack();
    });
  };

  render() {
    const { report, isLoading, selectedComment } = this.state;
    if (!report) return null;

    const { reference_day, data = "", time_unit } = report;

    const reflectionData = data ? JSON.parse(data) : {};
    const selectedJournals = ReportsHelper.getAllGems(
      reflectionData,
      reference_day,
      time_unit,
    );

    const intervalText = ReflectionHelper.getPeriodDisplayText(
      reference_day,
      time_unit,
    );

    const reportComments = sortBy(
      report.comments || [],
      (a) => moment.unix(a.datetime_created),
      "desc",
    );

    return (
      <View style={[appStyles.container, styles.container]}>
        <LoadingIndicator isLoading={isLoading} />

        <KeyboardAvoidingView
          behavior={"height"}
          style={appStyles.kbViewNoFooter}
          keyboardVerticalOffset={isWeb ? 0 : -20}
        >
          <Header
            title={"Discussion"}
            subTitle={intervalText}
            controller={this.controller}
            goBack={this.goBack}
          />

          {/* OVERALL REPORT COMMENT */}
          <View style={styles.overallComment}>
            <ReportJournalsList
              report={report}
              journals={selectedJournals}
              controller={this.controller}
              hideCommentsIcon
            />
          </View>

          {/* COMMENTS */}
          <ScrollView contentContainerStyle={appStyles.scrollViewContent}>
            <View style={styles.discussions}>
              {(reportComments || []).map((c, index) => (
                <ReportComment
                  key={index}
                  comment={c}
                  controller={this.controller}
                  onEditComment={this.editComment}
                  deleteComment={this.deleteComment}
                  marAsUnread={this.marAsUnread}
                />
              ))}
            </View>
          </ScrollView>

          {/* INPUT */}
          <CommentInput
            saveMessage={this.saveComment}
            selectedComment={selectedComment}
          />
        </KeyboardAvoidingView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: AppTheme.containerBg,
  },
  overallComment: {
    marginHorizontal: 8,
    borderRadius: 4,
    marginBottom: 8,
    marginTop: 8,
    backgroundColor: "#FFF",
    ...cardShadow,
  },
  discussions: {
    minHeight: 40,
    flex: 1,
  },
});
